module.exports = __webpack_public_path__ + "static/media/appstore-4b.c50009bc.png";